// 3rd-party
import { Routes, Route, Navigate } from "react-router-dom";
import { Box, CssBaseline } from "@mui/material";

// Screens
import Category from "./Category";
import StateData from "./StateData/StateData";
import StateActive from "./StateData/StateActive";
import Statelevel from "./Statelevel/Statelevel";
import India from "./india/India";
import IndiaPdf from "./indiaPdf/IndiaPdf";
import IntrodectoryVideo from "./introdectoryVideo/IntrodectoryVideo";
import Categorymain from "./categorymain/Categorymain";
import Categorysub from "./Categorysub";
import UserManagement from "./userManagement/UserManagement";
import AuditTrials from "./AuditTrials/AuditTrials";

// Components
import SidebarLayout from "../components/sidebarLayout/SidebarLayout";
import Header from "../components/header/Header";
import Home from "./pandingRequest/PandingRequest";
import StateIntroductiveVideo from "./StateData/StateIntroductiveVideo";
import StateImage from "./stateImage/StateImage";
import IndiaImage from "./indiaImage/IndiaImage";

function MasterPage() {
  return (
    <>
      <CssBaseline />

      <Header />

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "90vh",
          zIndex: "0",
        }}
      >
        <SidebarLayout />
        <Box
          sx={{
            flex: 1,
            marginLeft: "180px",
            marginTop: "60px",
            overflowY: "auto",
            height: "calc(100vh - 60px)",
            backgroundColor: "#f4f4f4",
          }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="India" replace />} />
            <Route path="India" element={<India />} />
            <Route path="home" element={<Home />} />
            <Route path="introdectoryVideo" element={<IntrodectoryVideo />} />
            <Route path="main" element={<Categorymain />} />
            <Route path="category" element={<Category />}>
              <Route path="main" element={<Categorymain />} />
              <Route path="sub" element={<Categorysub />} />
            </Route>
            <Route path="IndiaPdf" element={<IndiaPdf />} />
            <Route path="StateData" element={<StateData />} />
            <Route path="Statestatus" element={<StateActive />} />
            <Route path="Statesintro" element={<StateIntroductiveVideo />} />
            <Route path="Statelevel" element={<Statelevel />} />
            <Route path="Stateimage" element={<StateImage />} />

            <Route path="UserManagement" element={<UserManagement />} />
            <Route path="Audit" element={<AuditTrials />} />
            <Route path="Highlight" element={<IndiaImage />} />
          </Routes>
        </Box>
      </Box>
    </>
  );
}

export default MasterPage;
